import {UI} from "../../../stem-core/ui/UIBase";

// TODO @Mihai this file is a prototype of a generic input class lifecycle
// TODO @branch @Mihai merge the usage of this with InputableElement
export interface DashboardBaseInputOptions {
    value?: any;
    initialValue?: any;
    onChange?: ((value: any, source: any) => void) | null;
}

export class DashboardBaseInput<ExtraOptions = {}> extends UI.Element<DashboardBaseInputOptions & ExtraOptions> {
    // Written by setValue, which is the only place it comes from
    declare value?: any;

    // Overload only, so the emitted signature keeps its arity: subclasses pass their options up
    getDefaultOptions(options?: any): Record<string, any> | undefined;
    getDefaultOptions(): Record<string, any> | undefined {
        return {
            onChange: null,
            initialValue: null,
        };
    }

    getValue() {
        return this.value;
    }

    // Try not to use this method outside the class. Consider if updating the initialValue will be what you actually
    // want to do.
    setValue(value: unknown) {
        this.value = value;
        if (this.node) {
            this.redraw();
        }
    }

    // This should be overwritten in some cases.
    isEqual(valueA: unknown, valueB: unknown) {
        return valueA === valueB;
    }

    isChanged() {
        return !this.isEqual(this.options.initialValue, this.getValue());
    }

    setAndDispatchValue(value: unknown) {
        this.setValue(value);
        this.dispatchChange(value);
    }

    setOptions(options: this["options"]) {
        const oldInitialValue = this.options.initialValue;
        super.setOptions(options);
        const {initialValue} = this.options;
        if (oldInitialValue == null && initialValue == null) {
            return;
        }
        if (!this.node || !this.isEqual(initialValue, oldInitialValue)) {
            this.setValue(initialValue);
        }
    }

    dispatchChange(value: unknown) {
        this.dispatch("change", value, this);
    }
}
